// src/redux/bannerSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { publicRequest } from "../api/requestMethods";

// Fetch hero_carousel banners for the web landing page.
// Uses the slot-scoped endpoint so only ads assigned to this slot are returned,
// preventing retail_carousel or other slot ads from bleeding through.
export const fetchBanners = createAsyncThunk(
  "banners/fetchBanners",
  async (_, { rejectWithValue }) => {
    try {
      const response = await publicRequest.get(
        "/advert/slot/hero_carousel",
        { params: { deviceType: "all" } }
      );
      // Slot endpoint returns { items: [...] }
      const items = Array.isArray(response.data?.items)
        ? response.data.items
        : Array.isArray(response.data)
          ? response.data
          : [];
      return items;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch banners");
    }
  }
);

const bannerSlice = createSlice({
  name: "banners",
  initialState: {
    banners: [],
    desktopBanners: [],
    mobileBanners: [],
    isFetching: false,
    error: null,
  },
  reducers: {
    filterBannersByDevice: (state) => {
      state.desktopBanners = state.banners.filter(
        (b) => b.deviceType === "desktop" || b.deviceType === "all"
      );
      state.mobileBanners = state.banners.filter(
        (b) => b.deviceType === "mobile" || b.deviceType === "all"
      );
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.banners = action.payload;
        // Auto-filter by device type
        state.desktopBanners = action.payload.filter(
          (b) => b.deviceType === "desktop" || b.deviceType === "all"
        );
        state.mobileBanners = action.payload.filter(
          (b) => b.deviceType === "mobile" || b.deviceType === "all"
        );
        state.isFetching = false;
        state.error = null;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.error = action.payload;
        state.isFetching = false;
      });
  },
});

export const { filterBannersByDevice } = bannerSlice.actions;
export default bannerSlice.reducer;
